// extracted by mini-css-extract-plugin
module.exports = {"icon-container":"nothing-found-empty-state__icon-container___l3YaP"};